import React from 'react';
import * as S from './OverviewIntro.styles';

/**
 * Quick-facts intro block for how-to-play pages.
 * Renders a responsive grid of white cards (icon + title + short text),
 * styled like Conecta2's feature items.
 *
 * Props:
 *  - items: [{ icon: JSX, title: string, text: string }]
 */
const OverviewIntro = ({ items = [] }) => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <S.Grid>
      {items.map((item, idx) => (
        <S.Item key={idx} style={{ animationDelay: `${idx * 0.08}s` }}>
          {item.icon && <S.Icon>{item.icon}</S.Icon>}
          <S.Title>{item.title}</S.Title>
          <S.Text>{item.text}</S.Text>
        </S.Item>
      ))}
    </S.Grid>
  );
};

export default OverviewIntro;
